export default "__VITE_ASSET__cec1a08f__"